import React from 'react';
import { SvgIcon } from '@agilize/components-core';
import { Routes } from './Routing.types';

export const routes: Routes[] = [
  {
    label: 'Início',
    icon: <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/custom/dashboard.svg`} width={22} height={22} fill="grey400" />,
    path: '/',
    exact: true,
    navigable: false,
  },
  {
    label: 'Folhas de pagamento',
    icon: <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/unicons/money-stack.svg`} width={24} height={24} fill="grey400" />,
    path: '/folhas-pagamento',
    exact: false,
    navigable: true,
    alternativeUrls: ['/fechar-folha/:id?'],
  },
  {
    label: 'Quadro de funcionários',
    icon: <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/unicons/user-square.svg`} width={23} height={23} fill="grey400" />,
    path: '/funcionarios',
    exact: false,
    navigable: true,
  },
  {
    label: 'Processos',
    icon: <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/custom/board.svg`} width={22} height={22} fill="grey400" />,
    path: '/processos',
    exact: false,
    navigable: true,
  },
];
